/** @file PartsList: the Art screen's left column, one row per drawable with filled / total slots. */
import type { ReactElement } from 'react';
import type { ArtPart } from './artTypes';

/** The parts, the selected drawable and what selecting one does. */
export type PartsListProps = { parts: ArtPart[]; selected: string | null; onSelect: (drawable: string) => void };

/** A list of buttons: label, `filled / total`, a progress bar, `optional` for parts that may stay empty. */
export function PartsList({ parts, selected, onSelect }: PartsListProps): ReactElement {
  return (
    <nav aria-label="Parts" style={{ display: 'flex', flexDirection: 'column', gap: 2, padding: 8, overflow: 'auto' }}>
      {parts.map((p) => {
        const on = p.drawable === selected;
        const done = p.total === 0 ? 0 : p.filled / p.total;
        return (
          <button
            key={p.drawable}
            type="button"
            aria-pressed={on}
            data-part={p.drawable}
            onClick={() => { onSelect(p.drawable); }}
            style={{
              display: 'flex', flexDirection: 'column', gap: 3, padding: '6px 8px', textAlign: 'left', cursor: 'pointer',
              borderRadius: 4, border: 'none', color: '#e6e8ec', background: on ? '#2b3a55' : 'transparent', fontSize: 12,
            }}
          >
            <span style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
              <span>{p.label}{p.optional ? <em style={{ color: '#8a8f98', marginLeft: 6 }}>optional</em> : null}</span>
              <span style={{ color: p.filled === p.total ? '#3fa66b' : '#a9adb6' }}>{p.filled} / {p.total}</span>
            </span>
            <span style={{ display: 'block', height: 3, background: '#33363d', borderRadius: 2 }}>
              <span style={{ display: 'block', height: 3, width: `${done * 100}%`, background: '#3fa66b', borderRadius: 2 }} />
            </span>
          </button>
        );
      })}
    </nav>
  );
}
